import { FC, useEffect, useState } from "react";

import { PureVoidFunc } from "../../../helpers/functions/types";
import { NamedSwitch } from "../../../ui/layout/molecules/NamedSwitch";
import {
  COLLAPSED_WRAPPER_STYLES,
  MODAL_ROW_GROUP_STYLES,
} from "../../../ui/layout";

type CollapsedFieldsProps = {
  active: boolean;
  title: string;
  subtitle?: string;
  resetFields?: PureVoidFunc;
  activateFields?: PureVoidFunc;
  isSwitchable?: boolean;
  permissions?: string;
  customGroupStyles?: string;
  customWrapperStyles?: string;
  disabled?: boolean;
};

export const CollapsedFields: FC<
  React.PropsWithChildren<CollapsedFieldsProps>
> = ({
  title,
  subtitle,
  children,
  active,
  resetFields,
  activateFields,
  isSwitchable = true,
  permissions,
  customGroupStyles,
  customWrapperStyles,
  disabled,
}) => {
  const [showFields, setShowFields] = useState(active);

  const handleSwitchChange = (checked: boolean) => {
    setShowFields(checked);

    if (resetFields && !checked) {
      resetFields();
    }
    if (activateFields && checked) {
      activateFields();
    }
  };

  useEffect(() => {
    setShowFields(active);
  }, [active]);

  return (
    <div className={customGroupStyles ?? MODAL_ROW_GROUP_STYLES}>
      <NamedSwitch
        title={title}
        subtitle={subtitle}
        value={showFields}
        onChange={isSwitchable ? handleSwitchChange : undefined}
        permissions={permissions}
        disabled={disabled}
      />

      {showFields && (
        <div
          className={`${customWrapperStyles ?? COLLAPSED_WRAPPER_STYLES} empty:hidden`}
        >
          {children}
        </div>
      )}
    </div>
  );
};
